module.exports = __webpack_public_path__ + "images/fsoel_schnellrechner_scenario_1.svg?ed751f6e73c7987d454795f2d527af72";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fsoel_schnellrechner_scenario_1.svg
// module id = FuRd
// module chunks = 0